import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { MenuItem, Stack } from '@mui/material';
import useAxiosPrivate from '../../hooks/use-axios-private';
import Empty from '../../components/Empty';
import { useTheme } from '@emotion/react';
import Button from '@mui/material/Button';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useRef } from 'react';
import ModalBox from '../../components/ModalBox';
import { Grid, IconButton, Autocomplete, TextField as MuiTextField } from '@mui/material'
import { Field, Form, Formik } from 'formik';
import { Select, TextField } from 'formik-mui';
import { alertMsg } from '../../utils/basicUtils';
import * as Yup from 'yup';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Popup from '../../components/Popup';
import StrictNumberField from '../../components/StrictNumberField';
import { APP_CURRENCY } from '../../constants';

const headCells = [
    {
        id: 'id',
        numeric: false,
        disablePadding: true,
        label: 'ID',
    },
    {
        id: 'name',
        numeric: true,
        disablePadding: false,
        label: 'Name',
    },
    {
        id: 'price',
        numeric: true,
        disablePadding: false,
        label: `Price (${APP_CURRENCY.currency_symbol})`,
    },

    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
    },

];

const DEFAULT_ROWS_PER_PAGE = 5;

const EnhancedTableHead = (props) => {
    const { order, orderBy } =
        props;

    return (
        <TableHead>
            <TableRow sx={{ height: { xs: 65, xl: 70 } }}>
                <TableCell padding="checkbox">
                    {/* <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    /> */}
                </TableCell>
                {headCells.map((headCell, index) => (
                    <TableCell
                        key={index}
                        align={'center'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ whiteSpace: "nowrap" }}
                    >
                        {
                            // headCell.id !== 'action'
                            //     ?
                            //     <TableSortLabel
                            //         active={orderBy === headCell.id}
                            //         direction={orderBy}
                            //         onClick={() => createSortHandler(headCell.id)}
                            //     >
                            //         {headCell.label}
                            //         {orderBy === headCell.id && (
                            //             <Box component="span" sx={visuallyHidden}>
                            //                 {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            //             </Box>
                            //         )
                            //         }
                            //     </TableSortLabel>
                            //     :
                            headCell.label
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    //  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    // orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { numSelected, onSearchChange } = props
    const theme = useTheme()
    return (
        <>
            <Box sx={{ mt: 3 }}>
                <Toolbar
                    sx={{

                        px: 2,
                        ...(numSelected > 0 && {
                            bgcolor: (theme) =>
                                alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                        }),
                        alignItems: { xs: 'end' }
                    }}
                >
                    {numSelected > 0 ? (
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            color="inherit"
                            variant="subtitle1"
                            component="div"
                        >
                            {numSelected} selected
                        </Typography>
                    ) : (
                        <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'start', md: 'end' }} justifyContent='space-between' sx={{ width: '100%', mt: { xs: 2, md: 0 } }}>
                            <Typography
                                sx={{ flex: '1 1 100%', color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}
                                id="tableTitle"
                                component="div"
                            >
                                Services
                            </Typography>

                            <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} alignItems="end" justifyContent="end" sx={{ width: '100%' }}>

                                <Box sx={{ width: { xs: '100%', md: 300 }, maxWidth: '100%', pr: { xs: 0, sm: 2 } }}>
                                    <MuiTextField fullWidth label="Search" variant="standard" size="small" type='search' onChange={onSearchChange} autoComplete='off' />
                                </Box>
                            </Stack>
                        </Stack>
                    )}
                </Toolbar>
            </Box>
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


const Services = () => {
    const theme = useTheme()
    const [ascorder, setAscorder] = useState("desc")
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
    const [paddingHeight, setPaddingHeight] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [count, setCount] = useState(0);
    const axios = useAxiosPrivate()

    const [orderByJobs, setOrderByJobs] = useState([])
    const [rows, setRows] = useState([])
    const [serviceCategory, setServiceCategory] = useState([])
    const initialServiceValues = {
        name: '',
        price: '',
        description: '',
        file_type: '',
        preferences: [],
        before_image: {},
        after_image: {},
    }
    const [serviceValues, setServiceValues] = useState(initialServiceValues)
    const [id, setId] = useState(0)
    const [preferences, setPreferences] = useState([])
    const [servicePreferences, setServicePreferences] = useState([])
    const [deletePreferences, setDeletePreferences] = useState([])
    const preferencesRef = useRef()
    const [name, setPreferenceText] = useState('');
    const [open, setOpen] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const [serviceOperation, setServiceOperation] = useState('Create')
    const [showAlert, setShowAlert] = useState(false);
    const createServiceValidation = Yup.object({
        name: Yup.string()
            .required('Service name is required')
            .max(45, 'Service name cannot exceed 45 characters'),
        price: Yup.number()
            .required('Service Price is required')
            .min(0, `Service price shouldn't be negative`)
            .max(10000, 'Price cannot exceed 10000')
            .test(
                "DecimalPlaces",
                "Decimal places does not exceed 2 characters",
                (number) => Number.isInteger(number * 100)
            ),
        description: Yup.string()
            .required('Service description is required')
            .max(255, 'Service description cannot exceed 255 characters'),
    })
    const uploadImage = async (event, serviceImage) => {
        try {
            const ext = event.target.files[0].name.split('.').pop().toLowerCase();
            if (event.target.files[0].size < 10000000) {
                if (['jpg', 'jpeg', 'png'].includes(ext)) {
                    const formData = new FormData();
                    formData.append("service_id", id);
                    formData.append(serviceImage, event.target.files[0]);
                    const resp = await axios.post("services/upload_featured_image/", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    })
                    alertMsg(resp.data.message, "success")
                    if (serviceImage === 'before_image') {
                        setServiceValues(prev => {
                            return { ...prev, 'before_image': { ...resp.data.data } }
                        })
                    }
                    else {
                        setServiceValues(prev => {
                            return { ...prev, 'after_image': { ...resp.data.data } }
                        })
                    }
                }
                else {
                    alertMsg("Unsupported file format", 'warning')
                }
            }
            else {
                alertMsg("File size should be less than 10MB", 'warning')
            }
        }
        catch (e) {
            console.error(e)
            return false
        }
    }
    const getAllPreferences = async () => {
        let resp = await axios.get(`services/preferences/`);
        setPreferences(resp.data.data.preference)
    }

    const getServiceData = async (id) => {
        try {
            let resp = await axios.get(`services/${id}`);
            setServiceValues(resp.data.data.service)
            setPreferences(resp.data.data.available_preferences)
            setServicePreferences(resp.data.data.selected_preferences.map(ele => ({ name: ele.preference_name, id: ele.preference_id, price: ele.cost })))
        }
        catch (err) {
            console.error(err)
        }
    }
    const deleteService = async (id) => {
        try {
            let resp = await axios.delete('services/' + id)
            getServicesList()
            alertMsg(resp.data.message, 'success')
        } catch (e) {
            console.error("🚀 ~ file: Services.jsx:280 ~ deleteService ~ e:", e)
            alertMsg('Failed to delete', 'error')
        }
    }
    const getServicesList = async () => {
        try {
            const resp = await axios.get('services/', {
                params: {
                    limit: rowsPerPage, search: searchText, page: page + 1
                    , order_by: orderByJobs, order_by_type: ascorder,
                }
            })
            setCount(resp.data.data.page_info.count)
            setRows(resp.data.data.service)

        } catch (error) {
            console.error(error)
        }
    }
    const getServicesCategory = async () => {
        try {
            const resp = await axios.get("/services/categories/")
            setServiceCategory(resp.data.data.service_category_list)
            setServiceValues(prev => {
                prev.file_type = resp.data.data.service_category_list[0].category_id
                return prev
            })
            console.log("🚀 ~ file: Services.jsx:320 ~ getServicesCategory ~ resp:", resp)
        } catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        getServicesList()
    }, [rowsPerPage, searchText, page, ascorder, orderByJobs]);


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            return;
        }
        setSelected([]);
    };
    const orderChange = (newOrderBy) => {
        if (newOrderBy === 'action') {
            return false
        }

        if (ascorder === "desc") {
            setAscorder("asc")
            setOrderByJobs(newOrderBy)
        }
        else {
            setAscorder("desc")
            setOrderByJobs(newOrderBy)
        }
    }


    const handleChangePage = useCallback(
        (event, newPage) => {
            setPage(newPage)
        },
        []
    );

    const handleChangeRowsPerPage = useCallback(
        (event) => {
            const updatedRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(updatedRowsPerPage);
            setPage(0);
            // There is no layout jump to handle on the first page.
            setPaddingHeight(0);
        }, []
    );



    return (
        <>
            <Box sx={{ textAlign: "right" }}>
                <Button
                    variant='outlined'
                    onClick={async () => {
                        getServicesCategory()
                        setServiceValues(initialServiceValues);
                        setServicePreferences([])
                        setDeletePreferences([])
                        await getAllPreferences()
                        setServiceOperation('Create');
                        setModalOpen(true)
                    }}
                >Create Service</Button>
            </Box>

            <Box sx={{ width: '100%' }}>
                <Paper sx={{ width: '100%', mb: 2, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                    <Box>
                        <EnhancedTableToolbar
                            numSelected={selected.length}
                            onSearchChange={
                                (e) => {
                                    setSearchText(e.target.value)
                                }
                            }
                        />
                        {rows.length > 0
                            ?
                            <>
                                <TableContainer>
                                    <Table
                                        sx={{ minWidth: 750, mt: 3 }}
                                        aria-labelledby="tableTitle"
                                        size={'medium'}
                                    >
                                        <EnhancedTableHead
                                            numSelected={selected.length}
                                            //   order={order}
                                            //  orderBy={orderBy}
                                            onSelectAllClick={handleSelectAllClick}

                                            //  onRequestSort={orderChange}
                                            onRequestSort={(newOrderBy) => { orderChange(newOrderBy) }}
                                            rowCount={rows.length}
                                            orderBy={ascorder}
                                        />
                                        <TableBody>
                                            {rows
                                                && rows.map((row, index) =>
                                                    <TableRow sx={{ height: { xs: 65, lg: 70 } }} key={index}>
                                                        <TableCell>
                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.id}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.name}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{APP_CURRENCY.currency_symbol} {row.price}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">
                                                            <Box>
                                                                <IconButton
                                                                    sx={{ ml: 1 }}
                                                                    color="primary"
                                                                    onClick={async () => {
                                                                        setId(row.id)
                                                                        setServiceValues({ ...row })
                                                                        await getServiceData(row.id)
                                                                        setOpen(true);
                                                                    }}
                                                                    component="span"
                                                                >
                                                                    <CloudUploadOutlinedIcon />
                                                                </IconButton>

                                                                <IconButton sx={{ ml: 1 }} color="primary" component="span"
                                                                    onClick={async () => {
                                                                        setDeletePreferences([])
                                                                        setServiceValues({ ...row })
                                                                        await getServiceData(row.id)
                                                                        setModalOpen(true);
                                                                        setServiceOperation('Update')
                                                                    }}
                                                                >
                                                                    <EditOutlinedIcon />
                                                                </IconButton>
                                                                <IconButton sx={{ ml: 1 }}
                                                                    color='error'
                                                                    onClick={() => {
                                                                        setServiceValues({ ...row });
                                                                        setShowAlert(true);
                                                                    }}
                                                                    component="span">
                                                                    <DeleteOutlineOutlinedIcon />
                                                                </IconButton>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }

                                            {paddingHeight > 0 && (
                                                <TableRow
                                                    style={{
                                                        height: paddingHeight,
                                                    }}
                                                >
                                                    <TableCell colSpan={7} />
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        <Popup show={showAlert} onSecondaryClick={() => setShowAlert(false)} title={"Delete Services?"} consent={true} variant='error' primaryBtnTxt={"Delete"}
                                            onPrimaryClick={async (e, loader) => {
                                                if (e.detail !== 1) {
                                                    return false
                                                }
                                                try {
                                                    loader(true)
                                                    await deleteService(serviceValues.id)
                                                    setShowAlert(false)
                                                    loader(false)
                                                }
                                                catch (error) {
                                                    console.error(error)
                                                }
                                            }}

                                        >
                                            <Box sx={{ mt: 2, textAlign: "center" }}>
                                                <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Are you sure you want to delete</Typography>
                                                <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> {serviceValues.name} </Typography>
                                                <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Services?</Typography>
                                            </Box>
                                            <Box sx={{ marginTop: "6px", textAlign: "center" }}>
                                                <Typography sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>You can't undo this action.</Typography>
                                            </Box>
                                        </Popup>

                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={count}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />

                            </>
                            :
                            <Empty sx={{ border: "none" }} icon={<ManageAccountsOutlinedIcon sx={{ fontSize: 40, color: "grey" }} />} text="No service available" />
                        }
                    </Box>
                    <ModalBox
                        open={open}
                        onClose={() => { setOpen(false) }} >
                        <Box sx={{ maxHeight: "80vh", overflowY: "auto", pr: 1 }} className="overflow-scroll">
                            <Box sx={{}}>
                                {/* <Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }} variant='h5'>{serviceOperation} service</Typography> */}
                                {/* <Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : "comman.black" }} variant='h5'>{serviceOperation} service</Typography> */}
                                <Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 20, xl: 22 } }} >Update service image</Typography>
                            </Box>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <input
                                            type="file"
                                            onChange={(e) => { uploadImage(e, 'before_image') }}
                                            style={{ display: 'none' }}
                                            id="before_image"
                                        />
                                        <Box sx={{ maxHeight: { xs: 350 }, overflowY: 'auto', border: "2px dashed grey", mt: 3, borderRadius: "4px" }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pt: 6, px: 3, height: "100%", }}>
                                                <Box >
                                                    <label htmlFor="before_image">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            component="span"
                                                        >
                                                            BEFORE IMAGE

                                                        </Button>
                                                    </label>
                                                </Box>
                                            </Box>
                                            <Box sx={{ p: 3, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>
                                                {
                                                    serviceValues.before_image && serviceValues.before_image.url
                                                    &&
                                                    <Box sx={{ px: 2, pb: 2 }}>
                                                        <img src={serviceValues.before_image.url} alt="Service" width={150} height={150} style={{ borderRadius: "6px", objectFit: "cover" }} />
                                                    </Box>
                                                }
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <input
                                            type="file"
                                            onChange={(e) => { uploadImage(e, 'after_image') }}
                                            style={{ display: 'none' }}
                                            id="after_image"
                                        />
                                        <Box sx={{ maxHeight: { xs: 350 }, overflowY: 'auto', border: "2px dashed grey", mt: 3, borderRadius: "4px" }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pt: 6, px: 3, height: "100%", }}>
                                                <Box >
                                                    <label htmlFor="after_image">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            component="span"
                                                        >
                                                            AFTER IMAGE
                                                        </Button>
                                                    </label>
                                                </Box>
                                            </Box>
                                            <Box sx={{ p: 3, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>
                                                {
                                                    serviceValues.after_image && serviceValues.after_image.url
                                                    &&
                                                    <Box sx={{ px: 2, pb: 2 }}>
                                                        <img src={serviceValues.after_image.url} alt="Service" width={150} height={150} style={{ borderRadius: "6px", objectFit: "cover" }} />
                                                    </Box>
                                                }
                                            </Box>
                                        </Box>

                                    </Box>
                                </Grid>
                            </Grid>
                            <Box sx={{ mt: 4, textAlign: "right" }}>

                                <Button
                                    variant="outlined"
                                    color="error"
                                    sx={{ ml: 2 }}
                                    onClick={() => setOpen(false)}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </Box>
                    </ModalBox>

                    <ModalBox
                        open={modalOpen}
                        onClose={() => { setModalOpen(false) }} >
                        <Box sx={{ height: { xs: "80vh", md: 'auto' }, overflow: 'auto', px: 2 }} className="overflow-scroll">
                            <Box sx={{ mb: 4 }}>
                                <Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 20, xl: 22 } }}>{serviceOperation} service</Typography>
                            </Box>
                            <Formik
                                initialValues={serviceValues}
                                onSubmit={async (values, { setSubmitting }) => {
                                    let resp = false
                                    if (serviceOperation === 'Update') {
                                        try {
                                            resp = await axios.put(`services/${values.id}`, { ...values, preferences: servicePreferences, delete_preference: deletePreferences })
                                        } catch (e) {
                                            console.error("🚀 ~ file: Services.jsx:608 ~ onSubmit={ ~ e:", e)
                                            alertMsg('Failed to update service', 'error')
                                            return
                                        }
                                    } else {
                                        try {
                                            resp = await axios.post('services/', { ...values, preferences: servicePreferences })
                                        } catch (e) {
                                            console.error("🚀 ~ file: Services.jsx:616 ~ onSubmit={ ~ e:", e)
                                            alertMsg('Failed to create service', 'error')
                                            return
                                        }
                                    }
                                    setSubmitting(false);
                                    getServicesList()
                                    alertMsg(resp.data.message, 'success')
                                    setModalOpen(false)

                                }}
                                validationSchema={createServiceValidation}
                                enableReinitialize={true}
                            >
                                {({ submitForm, isSubmitting }) => (
                                    <Form>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Box>
                                                    <Field
                                                        sx={{ mb: 4 }}
                                                        component={Select}
                                                        formControl={{ fullWidth: true }}
                                                        name="file_type"
                                                        label="File type"
                                                    >
                                                        {serviceCategory.map(category => {
                                                            return (
                                                                <MenuItem value={category.category_id}>{category.category_name}</MenuItem>
                                                            )
                                                        })}

                                                    </Field>
                                                </Box>
                                                <Box>
                                                    <Field
                                                        sx={{ mb: 4 }}
                                                        component={TextField}
                                                        name="name"
                                                        label="Service Name *"
                                                        inputProps={{ maxLength: 45 }}
                                                        fullWidth
                                                    />
                                                </Box>
                                                <Box>
                                                    <StrictNumberField sx={{ mb: 4 }} name="price" label="Service Price *" inputProps={{ min: 1 }}
                                                        autoComplete='off' component={TextField} type="number" fullWidth />
                                                </Box>
                                                <Box>
                                                    <Field
                                                        sx={{ mb: 2 }}
                                                        component={TextField}
                                                        name="description"
                                                        label="Service Description *"
                                                        inputProps={{ maxLength: 255 }}
                                                        multiline
                                                        className="textAreaScroll"
                                                        rows={3}
                                                        fullWidth
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box sx={{ display: 'flex', alignItems: "center" }}>
                                                    <Autocomplete
                                                        inputValue={name}
                                                        onChange={(e, value, reason) => {
                                                            if (reason === "selectOption") {
                                                                setServicePreferences(prev => {
                                                                    if (!prev.find(ele => ele.name.toLowerCase() === value.name.toLowerCase())) {
                                                                        return [...prev, { 'id': value.id, 'name': value.name, 'price': 0 }]
                                                                    }
                                                                    else {
                                                                        alertMsg(`${value.name} already exist`, 'warning')
                                                                    }
                                                                    return prev
                                                                })
                                                            }
                                                        }}
                                                        onInputChange={(e, value, reason) => {
                                                            if (reason === "input") {
                                                                setPreferenceText(e.target.value)
                                                            } else if (reason === "clear") {
                                                                setPreferenceText('')
                                                            }
                                                        }}
                                                        onClose={(event, reason) => {
                                                            if (reason === 'createOption') {
                                                                let preferences_title = event.target.value
                                                                if (!preferences_title.trim()) {
                                                                    alertMsg('Please fill preferences title', 'warning')
                                                                    return false
                                                                }
                                                                setServicePreferences(prev => {
                                                                    if (!prev.find(ele => ele.name.toLowerCase() === preferences_title.toLowerCase())) {
                                                                        preferencesRef.current.value = ''
                                                                        setPreferenceText('')
                                                                        return [...prev, { 'name': preferences_title, 'price': 0 }]
                                                                    }
                                                                    else {
                                                                        alertMsg(`${preferences_title} already exist`, 'warning')
                                                                    }
                                                                    return prev
                                                                })
                                                            }
                                                        }}
                                                        clearOnBlur={true}
                                                        freeSolo
                                                        fullWidth
                                                        options={preferences}
                                                        getOptionLabel={(option) => option.name}
                                                        ListboxProps={{
                                                            className: "overflow-scroll"
                                                        }}
                                                        renderInput={(params) => (
                                                            <MuiTextField
                                                                {...params}
                                                                name="preferences"
                                                                label="Editing Preferences"
                                                                variant="outlined"
                                                                inputRef={preferencesRef}
                                                            />
                                                        )}
                                                    />
                                                    <Box>
                                                        <IconButton color="primary" onClick={() => {
                                                            let preferences_title = preferencesRef.current.value
                                                            if (!preferences_title.trim()) {
                                                                alertMsg('Please fill preferences title', 'warning')
                                                                return false
                                                            }
                                                            setServicePreferences(prev => {
                                                                if (!prev.find(ele => ele.name.toLowerCase() === preferences_title.toLowerCase())) {
                                                                    preferencesRef.current.value = ''
                                                                    setPreferenceText('')
                                                                    return [...prev, { 'name': preferences_title, 'price': 0 }]
                                                                }
                                                                else {
                                                                    alertMsg(`${preferences_title} already exist`, 'warning')
                                                                }
                                                                return prev
                                                            })
                                                        }} >
                                                            <AddCircleIcon />
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                                <Box sx={{ mt: 4 }}>
                                                    {servicePreferences.length > 0
                                                        ?
                                                        <Box sx={{ border: "1px solid #d4d4d4", borderRadius: "4px" }}>
                                                            <Box className="overflow-scroll" sx={{ pt: 1, borderRadius: "6px", maxHeight: "268px", overflowY: "auto", overflowX: "hidden" }}>
                                                                {servicePreferences.map((value, index) => (
                                                                    <Box sx={{ mt: 1 }} key={index}>
                                                                        <Grid container spacing={2} sx={{ alignItems: "center", px: 2, py: 1 }}>
                                                                            <Grid item xs={12} sm={6} md={7} lg={12} xl={7}>
                                                                                <Box>
                                                                                    <Typography sx={{ fontSize: "16px", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>{value.name}</Typography>
                                                                                </Box>
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={6} md={5} lg={12} xl={5}>
                                                                                <Box sx={{ display: 'flex' }}>
                                                                                    <Box sx={{ minWidth: 65 }}>
                                                                                        <MuiTextField
                                                                                            size="small"
                                                                                            label="Price"
                                                                                            type="number"
                                                                                            inputProps={{ min: 0 }}
                                                                                            // sx={{ minWidth:100 }}
                                                                                            variant="outlined"
                                                                                            fullWidth
                                                                                            defaultValue={value.price}
                                                                                            // value={value.price < 0 ? 0 : servicePreferences.price}
                                                                                            onKeyDown={(e) => {
                                                                                                (["e", "E", "+", "-"].includes(e.key) || (e.target.value === '' && e.key === '.')) && e.preventDefault()
                                                                                            }}
                                                                                            onChange={(e) => {
                                                                                                setServicePreferences(prev => {
                                                                                                    let pref = [...prev]
                                                                                                    pref[index].price = e.target.value
                                                                                                    return pref
                                                                                                })
                                                                                            }}
                                                                                        />
                                                                                    </Box>
                                                                                    <IconButton color='error' onClick={() => {
                                                                                        setServicePreferences(prev => {
                                                                                            let pref = [...prev]
                                                                                            pref.splice(index, 1)
                                                                                            return pref
                                                                                        })
                                                                                        setDeletePreferences(prev => {
                                                                                            return [...prev, value.id]
                                                                                        })
                                                                                    }} >
                                                                                        <DeleteOutlineOutlinedIcon />
                                                                                    </IconButton>
                                                                                </Box>
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Box sx={{ borderBottom: "1px solid #e8e8e8", pt: 1 }}></Box>
                                                                    </Box>
                                                                ))}
                                                            </Box>
                                                        </Box>
                                                        :
                                                        <Box sx={{ height: { xs: "auto", sm: 300 } }}>
                                                            <Empty sx={{ textTransform: "capitalize" }} icon={<SettingsOutlinedIcon sx={{ fontSize: 30, color: "grey" }} />} text="no preferences added" />
                                                        </Box>
                                                    }
                                                </Box>

                                            </Grid>
                                        </Grid>
                                        <Box sx={{ mt: 4, textAlign: "right" }}>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                sx={{ mr: 2 }}
                                                onClick={() => setModalOpen(false)}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isSubmitting}
                                                onClick={submitForm}
                                            >
                                                Submit
                                            </Button>
                                        </Box>
                                    </Form>
                                )}
                            </Formik>
                        </Box>
                    </ModalBox>
                </Paper>
            </Box>
        </>

    )
}

export default Services